module.exports = __webpack_public_path__ + "static/media/landing-mngr.ce379e81.svg";